import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.00145 5.4976C7.45908 5.4976 8.64072 4.37885 8.64072 2.9988C8.64072 1.61875 7.45908 0.5 6.00145 0.5C4.54382 0.5 3.36218 1.61875 3.36218 2.9988C3.36218 4.37885 4.54382 5.4976 6.00145 5.4976Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.09998 11.2109C1.09998 8.64799 3.29445 6.57031 6.00147 6.57031C8.70849 6.57031 10.903 8.64799 10.903 11.2109",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPerson;
